import * as React from "react"

export const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window === "undefined") {
      return false
    }
    return window.innerWidth < MOBILE_BREAKPOINT
  })
  const debounceRef = React.useRef<number | null>(null)

  React.useEffect(() => {
    if (typeof window === "undefined") {
      return
    }

    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      if (debounceRef.current) {
        window.clearTimeout(debounceRef.current)
      }
      debounceRef.current = window.setTimeout(() => {
        setIsMobile(window.innerWidth < MOBILE_BREAKPOINT)
      }, 100)
    }

    mql.addEventListener("change", onChange)
    return () => {
      if (debounceRef.current) {
        window.clearTimeout(debounceRef.current)
      }
      mql.removeEventListener("change", onChange)
    }
  }, [])

  return isMobile
}
